import { simpleSet } from '@r/reducers/utils';
import { px } from 'decl/general/units';

const setX = simpleSet as redux.reducers.modals.object3dModal.x;

export const x = setX( 'SET_OBJECT_3D_MODAL_X', 0 as px );
